import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnsortedKeyValuePipe } from './unsorted-key-value.pipe';



@NgModule({
  declarations: [
    UnsortedKeyValuePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UnsortedKeyValuePipe
  ]
})
export class UnsortedKeyValueModule { }
